var mainW = 0;
var curLang = '';

$(function(){

  $('a[href="#toggle-sizes"]').click(function(e){
    e.preventDefault();
    // $('.collection-sizes--opts').toggle();
  });
  
  $('.collection-sizes--opts a').unbind('click').click(function(e){
    e.preventDefault();
    $('.collection-sizes--opts a').not(this).removeClass('act');
    $(this).toggleClass('act');
    if($(this).hasClass('act')){
      var seekSize = 'size_'+$(this).attr('href').substr(1);
      console.log(seekSize);
      $('.grid__item').each(function(){
        var sizes = $(this).attr('data-sizes');
        if (sizes && sizes.indexOf(seekSize)>-1) {
          $(this).show();
          // $(this).parent().show();
        } else {
          $(this).hide();
          // $(this).parent().hide();
        }
      })
      // $('.product-item:not([data-sizes*="'+sz+'"])').fadeOut(200);
      // $('.product-item:[data-sizes*="'+sz+'"]').fadeIn(200);
    } else {
      $('.grid__item').show();
      $('a[href="#all"]').addClass('act');
    }

    if($('.grid__item:visible').length==0) {
      $('.grid-uniform').addClass('empty');
    } else {
      $('.grid-uniform').removeClass('empty');
    }
  });
  /*
  $('.ly-languages-switcher-link').each(function(){
    var t = $(this).text().substr(0,2);
    if(t=='Su'){ t = 'FI'; }
    $(this).text(t);
    console.log(t);
  });
  $('.ly-languages-switcher-link').each(function(){
    var t = $(this).text().substr(0,2);
    if(t=='Su'){ t = 'FI'; }
    $(this).text(t);
    console.log(t);
  });
  */
  var langAs = $('#ly-languages-switcher a');
  $('#ly-languages-switcher').empty().append(langAs);
  
  // curLang = $("#ly-languages-switcher #"+langify.helper.getCurrentLanguage());
  setTimeout(function(){
  if(langify.helper) {
    curLang = langify.helper.getCurrentLanguage();
    if(curLang=='fi'){
      $('body').addClass('lang-fi');
    }
  }
  }, 1000);
  // $("#xx-lang a").click(function(e){ e.preventDefault(); });
  
  if(window.innerWidth <= 768){
    $("#xx-lang").appendTo($("#AccessibleNav"));
  } else {
    $("#xx-lang").prependTo(".site-nav-right");
  }
  
  if($('html').hasClass('supports-js')){
    $('main.main-content').css('opacity',1);
        
    /*
    window.onbeforeunload = function() {
    $('main.main-content').css('opacity',0);
    };
    */
  }

  mainW = $('main.main-content').outerWidth();

  var vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', vh+'px');
  
  $(window).resize(function(){
    if(mainW!==$('main.main-content').outerWidth()){
      var vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', vh+'px');
    }
    mainW = $('main.main-content').outerWidth();
    
    if(window.innerWidth <= 768){
      $("#xx-lang").appendTo($("#AccessibleNav"));
    } else {
      $("#xx-lang").prependTo(".site-nav-right");
    }
    
  });
  
  $('.grid__item a').mouseenter(function(){
    $(this).parents('.grid__item').addClass('hov');
  }).mouseleave(function(){
    $(this).parents('.grid__item').removeClass('hov');
  });
  
  
  if($('body').hasClass('template-index')){
    
    if($("#Hero .hero__slide").first().css('background-image')){
      var firsthero = $("#Hero .hero__slide").first().css('background-image').split('"')[1];
      $('<img/>').attr('src', firsthero).on('load', function() {
        $(this).remove();
        $("#Hero").addClass("first-loaded");
      });
    }

      /*
    var feed = new Instafeed({
        get: 'user',
        //        tagName: 'viiksimaisteri',
        userId: '295072455',
        limit: 5,
	    resolution: 'standard_resolution',
        clientId: '9a620633e69141cbb711ea7faf320523',
        accessToken: '295072455.9a62063.8a4eeca63e6f4eb18a57c3559746de46', // terhi
//        accessToken: '942228572.9a62063.2f0c7656c8cd4d62b4cff7e3d8fd3e10', // viiksi
        template: '<a class="ig_pic" href="{{link}}" target="_blank"><img src="{{image}}" /></a>'
    });
    feed.run();
    */
  }
  /*
  if($('body').hasClass('template-product')){
    $(window).scroll(function(){
      var arg = $(window).scrollTop() + $(window).height() > $('footer.site-footer').position().top;
      if(arg){
        $('.product-single__photos').addClass('atbtm');
      } else {
        $('.product-single__photos').removeClass('atbtm');        
      }
    }); 
  }
  */
  /*
  $(window).load(function(){
    if($('body').hasClass('template-index')){
      if($('#instafeed').children().length === 0){
        var feed = new Instafeed({
            get: 'user',
            //        tagName: 'viiksimaisteri',
            userId: '295072455',
            limit: 5,
            resolution: 'standard_resolution',
            clientId: '9a620633e69141cbb711ea7faf320523',
            accessToken: '942228572.9a62063.2f0c7656c8cd4d62b4cff7e3d8fd3e10', // terhi
    //        accessToken: '942228572.9a62063.2f0c7656c8cd4d62b4cff7e3d8fd3e10', // viiksi
            template: '<a class="ig_pic" href="{{link}}" target="_blank"><img src="{{image}}" /></a>'
        });
        feed.run();
      }
    }
  });
  */
  /*
  $('.force div:empty').remove();
  $('.force div').each(function(){
	  if($(this).html().length<4){ $(this).remove(); }
  });
  $('.force').addClass('d');
  */
  
  $("ul li a[href*='vat-'], ul li a[href*='size-']").parent("li").remove();
  
  $('.tabled-content table').each(function(){
    $(this).find('tr').each(function(){
      var divRow = $('<div class="table-row"></div>');
      $('.tabled-content').append(divRow);
      $(this).find('td').each(function(){
        var divCol = $('<div class="table-col"></div>');
        if($(this).find('h1').length>0){
          divCol.addClass('title');
          $(this).find('h1').prependTo($(this));
        }

        if($(this).find('img:not([alt*="kuvakuva"])').length>0){
          var img = $(this).find('img');
          var a = $(img).attr('alt');
          if(img.length===1 && a!=='kuvakuvana'){
            divCol.addClass('bgd');
            var s = $(img).attr('src');
            var a = $(img).attr('alt');
            if(a=='fit'){
              divCol.addClass('contain');
            }
            divCol.css('background-image','url('+s+')');

            var margs = $(img).css("margin");
            if(margs){
              var margsplit = margs.split(" ");
              var top = parseInt(margsplit[0]);
              var right = parseInt(margsplit[1]);
              var btm = parseInt(margsplit[2]);
              var left = parseInt(margsplit[3]);
              var doMargs = false;
              var x = 50;
              var y = 50;
              if(top==100 && btm==0) { y = 0; doMargs = true; }
              if(right==100 && left == 0) { x = 100; doMargs = true; }
              if(btm==100 && top == 0) { y = 100; doMargs = true; }
              if(left==100 && right == 0) { x = 0; doMargs = true; }
            //  if(doMargs){
                divCol.css('background-position',x+'% '+y+'%');
            //  }
            }
            
          } else {
            divCol.removeClass('bgd');
          }
        } else if($(this).find('img:not([alt*="kuvakuva"])').length===0) {
          divCol.addClass('txtd');
        }

        if(divCol.hasClass('txtd')){
          var divWrap = $('<div class="table-col-wrap"></div>');
          divWrap.html($(this).html());
          divCol.append(divWrap);
        } else {
          divCol.html($(this).html());
        }
        divRow.append(divCol);
      });
      divRow.addClass('cols-'+divRow.children().length);
    });
    $(this).remove();
  });
  $('.table-col meta').each(function(){
    if($(this).is(':only-child')) $(this).parent().remove(); 
  });
  $('.table-col div').each(function(){
    if($(this).is(':only-child') && $(this).is(':empty')) $(this).parent().remove(); 
  });
  $('.table-col.bgd').each(function(){
    var container = $(this);
    var h5 = $(this).find('h5');
//    console.log("h5s",h5);
    if(h5.length>0){
      $(h5).each(function(){
        if($(this).text().length<4){
          $(this).remove();
        } else {
          if(container.find('contain')){
            var img = container.find('img');
            $(this).insertAfter(img);
            img.parent().addClass('capt-cont');
          } else {
            container.addClass('capt-cont');          
          }
        }
      });
    }
  });
  $('.tabled-content > *').not('.table-row').remove();
  $('.table-row').each(function(){
    var bgd = $(this).children('.bgd');
    if(bgd){
      var idx = bgd.index();
//      console.log(idx);
      var nxt = $(this).next('.table-row');
      if(nxt.length>0){
        if(nxt.children('.bgd').length>0){
          var nxtidx = nxt.children('.bgd').index();
        }
        if(idx!==nxtidx){
          if(!$(this).hasClass('cols-1')){
            $(this).addClass('nomarginbtm');
          }
        }
      }
    }
  });
  /*
  $('.tabled-content table td img').each(function(){
    if($(this).parent('div').length===0){
        var div = $('<div></div>');
        $(div).appendTo($(this).parent());
        $(this).appendTo(div);
    }
  });

  $('.tabled-content table').each(function(){
    $(this).children('div').each(function(){
      if($(this).is(':empty')){ $(this).remove(); }
	  if($(this).html().length<4){ $(this).remove(); }
    });
  });
  $('.tabled-content table td').each(function(){
    if($(this).text().length<20){
        $(this).addClass('bgd');
        var img = $(this).find('img');
     //   console.log(img.length);
        if(img.length===1){
        var s = $(img).attr('src');
     //   console.log(s);
            $(this).css('background-image','url('+s+')');
        } else {
            $(this).removeClass('bgd');
        }
    } else if($(this).find('img').length===0) {
    	$(this).addClass('txtd');
    } else {
    	$(this).addClass('txtd');
    }
    
    if($(this).find('iframe').length>0){
        $(this).addClass('has-vid');
    }
  });
  $('.txtd').each(function(){
    var wrap = $('<div class="txtd-wrap"></div>');
    $(this).children().appendTo(wrap);
    $(this).append(wrap);
  });
  */
  
  
  $("a[href*='twitter'],a[href*='facebook'],a[href*='instagram']").attr("target","_blank");

  
  $(window).load(function(){
    $('.hires').each(function(){
      var src = $(this).attr('data-src');
      $(this).css('background-image','url("'+src+'")');
      $(this).addClass('done');
    });
  });
  
  if(!readCookie('on_ok') && !$('#keksi').length){
    var txt = 'This website uses cookies. By continuing to browse the site you are agreeing to our use of cookies. <a href="https://shop.terhipolkki.com/pages/privacy-policy">Read our Privacy Policy here</a>.'
    var notify = $('<div id="keksi" class="hid"><span class="ehto">'+txt+'</span><div class="button is_ok"><span>OK</span></div></div>');
    $('body').append(notify);
    setTimeout(function(){ 
      $('#keksi').removeClass('hid'); 
      $('body').addClass('keksi-showing');
    },100);
    
    $('#keksi .is_ok').click(function(){
      createCookie('on_ok','true',365);
      $('#keksi').addClass('hid');
      $('body').removeClass('keksi-showing');
	});
  }
});


function initProduct(){



    $('.single-option-radio[name="Color"]').parent().remove();

     $('.product-single__description').each(function(){

       $(this).children('h4:empty').remove();

       $(this).children('h4').each(function(){
         if($(this).text().length<1){
           $(this).remove();
           return;
         }
         /*
          if($(this).children('p').length>0){
            $(this).children().insertBefore($(this));
            $(this).remove();
            return;
          }
          */
       });

       $('.product-single__description strong').each(function(){
         var t = $(this).text();
         var ogtext = t;
         t = deUmlaut(t.toLowerCase());
         if(t=='color' || t=='vari'){
           if($(this).parent('p').length==1){
             console.log(t);
             $(this).unwrap().wrap('<h4 />');

             var capitalized = ogtext.toLowerCase();
             capitalized = capitalized.charAt(0).toUpperCase() + capitalized.substring(1);
             $(this).parent('h4').html(capitalized);
           }
         }
       });


       $(this).children('h4').each(function(){

         var nexts = $(this).nextUntil('h4');
         var id = $(this).text().toLowerCase().replace(/\s/g, '').replace(/[^\w\s]/gi, '');
         id = deUmlaut(id);
         if(id!=='color' && id!=='vari' && id!=='vri'){
           if($(".meta-sect#"+id).length==0){
             var wrap = $('<div id="'+id+'" class="meta-sect"></div>');
             $(this).wrap(wrap);
             $(this).append('<span class="icon icon-arrow-down" aria-hidden="true"></span>');
           } else {
             $(this).remove();
           }
           $('.meta-sect#'+id).append('<div class="meta-sect-cont"></div>');
           nexts.appendTo($('.meta-sect#'+id+' .meta-sect-cont'));
         } else {
           var wrap = $('<div class="color-options"></div>');
           $(this).wrap(wrap);
           nexts.find('a').appendTo($('.color-options')).addClass('color-option');
           nexts.remove();
           $('.color-options').prependTo($('.variants-wrap'));
         }
       });
       $('a.color-option').each(function(){
         if($(this).children().length==0){ $(this).remove(); }
       });
       $('.meta-sect h4').unbind('click').click(function(){
         $(this).toggleClass('open');
         $(this).siblings('.meta-sect-cont').stop().toggle({
           duration: 200,
           progress: function(){
             checkFixedPositions();
           },
         });
       });


     });

     if(curLang=='fi'){
       if($("#details h4").text().trim().toLowerCase()=='details'){
         $("#details h4").text('Tuotetiedot');
       }
     }
    }


function getImageLightness(imageSrc,callback) {
    var img = document.createElement("img");
    img.src = imageSrc;
    img.style.display = "none";
    document.body.appendChild(img);

    var colorSum = 0;

    img.onload = function() {
        // create canvas
        var canvas = document.createElement("canvas");
		
        canvas.width = this.width;
        canvas.height = this.height;

        var ctx = canvas.getContext("2d");
        ctx.drawImage(this,0,0);

        var imageData = ctx.getImageData(0,0,canvas.width,canvas.height);
        var data = imageData.data;
        var r,g,b,avg;

        for(var x = 0, len = data.length; x < len; x+=4) {
            r = data[x];
            g = data[x+1];
            b = data[x+2];

            avg = Math.floor((r+g+b)/3);
            colorSum += avg;
        }

        var brightness = Math.floor(colorSum / (this.width*this.height));
        callback(brightness);
    }
	img.remove();
}

function getBrightness(c){
	c = c.substring(1);      // strip #
	var rgb = parseInt(c, 16);   // convert rrggbb to decimal
	var r = (rgb >> 16) & 0xff;  // extract red
	var g = (rgb >>  8) & 0xff;  // extract green
	var b = (rgb >>  0) & 0xff;  // extract blue

	var luma = 0.2126 * r + 0.7152 * g + 0.0722 * b; // per ITU-R BT.709
	return luma;
}



function createCookie(name,value,days) {
  if (days) {
      var date = new Date();
      date.setTime(date.getTime()+(days*24*60*60*1000));
      var expires = "; expires="+date.toGMTString();
  }
  else var expires = "";
  var domain = document.location.origin.split("https://")[1];
  document.cookie = name+"="+value+expires+";domain="+domain+"; path=/"; 
}

function readCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for(var i=0;i < ca.length;i++) {
      var c = ca[i];
      while (c.charAt(0)==' ') c = c.substring(1,c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
  }
  return null;
}

function eraseCookie(name) {
	createCookie(name,"",-1);
}

/*
* Shuffle jQuery array of elements - see Fisher-Yates algorithm
*/
jQuery.fn.shuffle = function () {
    var j;
    for (var i = 0; i < this.length; i++) {
        j = Math.floor(Math.random() * this.length);
        $(this[i]).before($(this[j]));
    }
    return this;
};

function deUmlaut(value){
  value = value.toLowerCase();
  value = value.replace(/ä/g, 'a');
  value = value.replace(/ö/g, 'o');
  value = value.replace(/ü/g, 'u');
  value = value.replace(/ß/g, 's');
  value = value.replace(/ /g, '-');
  value = value.replace(/\./g, '');
  value = value.replace(/,/g, '');
  value = value.replace(/\(/g, '');
  value = value.replace(/\)/g, '');
  return value;
}
